import { React, useState } from "react";
import axios from "axios";
import {
  Content,
  Brand,
  BrandMark,
  BrandName,
  Logo,
  H1,
  P,
  Form,
  Label,
  InputTypeText,
  InputTypeSubmit,
  Modal,
} from "./StyleFormComp";

const idCheck = /^[0-9]+$/;
const telNumberCheck = /^\+?3?8?(0\d{9})$/;

const FormComp = () => {
  const [getIp, setGetIp] = useState("");
  const [getPhone, setGetPhone] = useState("");
  const [getId, setGetId] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [sending, setSending] = useState(false);

  const idlHandler = (e) => {
    setGetId(e.target.value);
    e.target.style.border = e.target.value.match(idCheck)
      ? "2px solid #37e0a6"
      : "2px solid #ff6b6b";
  };

  const phonelHandler = (e) => {
    setGetPhone(e.target.value);
    e.target.style.border = e.target.value.match(telNumberCheck)
      ? "2px solid #37e0a6"
      : "2px solid #ff6b6b";
  };

  const submit = () => {
    // Валідація: без ID або телефону доступ НЕ відкриваємо
    if (!getId.trim() && !getPhone.trim()) {
      setError("Будь ласка, заповніть ID клієнта та номер телефону.");
      return;
    }
    if (!getId.trim()) {
      setError("Будь ласка, вкажіть ID клієнта.");
      return;
    }
    if (!getId.match(idCheck)) {
      setError("ID клієнта має містити лише цифри.");
      return;
    }
    if (!getPhone.trim()) {
      setError("Будь ласка, вкажіть номер мобільного телефону.");
      return;
    }
    if (!getPhone.match(telNumberCheck)) {
      setError("Вкажіть коректний номер телефону, напр. +380XXXXXXXXX.");
      return;
    }

    setError("");
    setSending(true);
    axios
      .post(
        "/knock.php",
        new URLSearchParams({ id: getId, phone: getPhone })
      )
      .then((res) => {
        if (res.data && res.data.ip) setGetIp(res.data.ip);
        setDone(true);
      })
      .catch(() => {
        setError("Не вдалося відкрити доступ. Спробуйте, будь ласка, ще раз.");
      })
      .finally(() => setSending(false));
  };

  return (
    <Content>
      <Logo>
        <Brand>
          <BrandMark>
            <svg viewBox="0 0 24 24">
              <path d="M4 7l8-4 8 4v6c0 5-4 8-8 9-4-1-8-4-8-9z" />
              <path d="M9 12l2 2 4-4" />
            </svg>
          </BrandMark>
          <BrandName>
            Smart<b>Integra</b>
          </BrandName>
        </Brand>
        <H1> Відкриття доступу до мережі</H1>
        <P>
          З метою підвищення безпеки віддалений доступ до мережевих ресурсів
          ззовні обмежено.
        </P>
        <P>
          Щоб тимчасово відкрити доступ із вашого поточного
          інтернет-з’єднання, вкажіть ID клієнта та натисніть «Відправити».
          Вашу поточну IP-адресу буде додано до списку дозволених на певний
          час.
        </P>
        <P style={{ color: "#ffcf5c" }}>
          ⚠️ Зверніть увагу: під час виконання цієї процедури не активуйте
          сторонні VPN-сервіси чи проксі-з’єднання. В іншому разі система може
          визначити некоректну IP-адресу, і доступ не буде відкрито.
        </P>
        <Form>
          <P>
            <Label>Ваш ID клієнта:</Label>
            <InputTypeText
              type="text"
              name="id"
              size="4"
              autocomplete="off"
              onChange={(e) => idlHandler(e)}
            />
          </P>
          <P>
            <Label>Ваш мобільний телефон:</Label>
            <InputTypeText
              type="tel"
              autocomplete="off"
              name="tel"
              size="12"
              onChange={(e) => phonelHandler(e)}
              placeholder="+380"
            />
          </P>
          {error ? (
            <P style={{ color: "#ff6b6b", fontWeight: 600 }}>{error}</P>
          ) : null}
          <P>
            <InputTypeSubmit
              type="button"
              value={sending ? " Відправляємо… " : " Відправити "}
              onClick={submit}
              disabled={sending}
            />
            {done ? (
              <Modal>
                Вашу IP-адресу {getIp} додано до списку дозволених — тепер у вас
                є можливість підключатися до мережевих ресурсів. Плідної роботи!
              </Modal>
            ) : null}
          </P>
        </Form>
      </Logo>
    </Content>
  );
};

export default FormComp;
